<template>
    <div ref='bottomFullView' class="loadingStateView" v-if="state > 0">
      <div>
        <baseLoadStateview :imageUrl="getImgWithState()" :title="getTitleWithState()"/>
        <div class="btnRefresh" v-if="state == 2 && refreshHandle != NaN" @click="refreshHandle">
          {{ $t('noticeView.refreshBtnTitle') }}
        </div>
      </div>
    </div>
</template>

<script>
import { bottomFullMixin } from './index.js'

export default {
  props: {
    state: { // 0不显示 1加载中 2网络错误 3无数据
      type: Number,
      default: () => 0
    },
    refreshHandle: null
  },
  mixins: [
    bottomFullMixin
  ],
  methods: {
    getImgWithState: function () {
      switch (this.state) {
        case 2:
          return require('../assets/noticeNetError.png')
        case 3:
          return require('../assets/noticeNoData.png')
        case 1:
        default:
          return require('../assets/noticeLoading.gif')
      }
    },
    getTitleWithState: function () {
      switch (this.state) {
        case 2:
          return this.$t('noticeView.netError')
        case 3:
          return this.$t('noticeView.noData')

        case 1:
        default:
          return this.$t('noticeView.loading')
      }
    }
  }
}
</script>

<style lang="sass">
.loadingStateView
  box-sizing: border-box
  display: flex
  align-items: center
  justify-content: center
  text-align: center

.btnRefresh
  color: #5F9DF5
  margin-top: 15px
  padding: 5px 10px
  border: 1px solid #5F9DF5
  border-radius: 12px
</style>
